import React from 'react';
import { Box, Typography } from '@mui/material';

const InvoiceHeader = ({ formData }) => {
  return (
    <Box sx={{ marginBottom: '20px' }}>
      <Typography sx={{ color: '#24e4ff', fontSize: '14px' }}>
        Contact Name: {formData.contactName}
      </Typography>
      <Typography sx={{ color: '#24e4ff', fontSize: '14px' }}>
        Company Name: {formData.companyName}
      </Typography>
      <Typography sx={{ color: '#24e4ff', fontSize: '14px' }}>
        Price List: {formData.priceList}
      </Typography>
      <Typography sx={{ color: '#24e4ff', fontSize: '14px' }}>
        Invoice / P.O. No.: {formData.invoiceNumber}
      </Typography>
    </Box>
  );
};

export default InvoiceHeader; 